import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddUsersService } from '../../service/add-users.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  DataNewUser,
  UpdateDataNewUser,
} from '../interface/add-user.interface';

@Component({
  selector: 'app-modal-edit',
  templateUrl: './modal-edit.component.html',
  styleUrls: ['./modal-edit.component.scss'],
})
export class ModalEditComponent {
  public form!: FormGroup;
  public hide: boolean = true;
  public rutUser: number;

  constructor(
    private fb: FormBuilder,
    private _userService: AddUsersService,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {}
  ngOnInit(): void {
    this.form = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      phone: ['', [Validators.required]],

      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      rut: ['', [Validators.required]],
      roles: ['', [Validators.required]],
      password: ['', [Validators.required]],
      confirmPassword: ['', Validators.required],
    });
    const rutUser = parseInt(this.data.substring(0, this.data.length - 1));
    this.getUserDetail(rutUser);
  }
  getUserDetail(rut: number) {
    this._userService
      .getUserId(rut)
      .subscribe((e) => this.fillUpdateWithUser(e.result));
  }

  private fillUpdateWithUser(user: DataNewUser) {
    this.form.patchValue({
      firstName: user.firstName,
      lastName: user.lastName,
      phone: user.phone,
      rut: user.rut,
      email: user.email,
      password: user.password,
    });
  }

  public async submitUpdate() {
    const request: UpdateDataNewUser = {
      rut: this.form.get('rut')?.value,
      firstName: this.form.get('firstName')?.value,
      lastName: this.form.get('lastName')?.value,
      email: this.form.get('email')?.value,
      phone: this.form.get('phone')?.value,
      roles: this.form.get('roles')?.value,
    };

    // this._userService.updateUser(request).subscribe({
    //   next: (res) => this.dialogRef.close(res.data),
    // });
  }

  
}
